import React from 'react';
import PropTypes from 'prop-types';
import styles from './Radio.module.scss';

const Radio = ({ checked, onChange, children }) => (
  <span className={styles.root}>
    <input type="radio" className={styles.radio} checked={checked} onChange={(event) => onChange && onChange(event)} />
    <span className={styles.radioContent}>{children}</span>
    <span className={styles.radioMark} />
  </span>
);

Radio.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  children: PropTypes.node.isRequired
};

Radio.defaultProps = {
  checked: false,
  onChange: null
};

export { Radio };
